import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddBanner() {
    const [bannerTitle, setBannerTitle] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    const handleImageUpload = async (e) => {
        const data = new FormData();
        data.append("image", e.target.files[0]);
        try {
            const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
            if (res?.image) {
                setImage(res.image);
                toast.success("Image uploaded successfully!");
            }
        } catch (error) {
            toast.error("Failed to upload image.");
            console.error("Error uploading image:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            title: bannerTitle,
            description: description,
            image: image,
        };
        try {
            const res = await HomeService.addBanner(data);
            if (res?.status) {
                toast.success("Banner added successfully!");
                clearAddForm();
                navigate("/manage-banner");
            }
        } catch (error) {
            toast.error("Failed to add banner.");
            console.error("Error adding banner:", error);
        }
    };

    const clearAddForm = () => {
        setBannerTitle("");
        setDescription("");
        setImage(null);
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">
                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Banner
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="name">
                                        Banner Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="form-control"
                                        value={bannerTitle}
                                        onChange={(e) => setBannerTitle(e.target.value)}
                                        placeholder="Enter banner name"
                                    />
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="description">
                                        Banner Description
                                    </label>
                                    <textarea
                                        id="description"
                                        className="form-control"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Enter banner description"
                                        rows="3"
                                    ></textarea>
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="bannerImage">
                                        Upload Banner Image<span className="text-danger">*</span>
                                    </label>
                                    {image && (
                                        <img
                                            src={image}
                                            alt="Banner Preview"
                                            style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                                        />
                                    )}
                                    <input
                                        type="file"
                                        id="bannerImage"
                                        className="form-control"
                                        onChange={handleImageUpload}
                                        accept="image/*"
                                        required
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="btn  mt-3"
                                style={{
                                    background: 'rgb(133, 218, 79)',
                                    borderRadius: '13px'
                                }}
                            >
                                Add Banner
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddBanner;
